import { InboundShipment } from "@deliverr/inbound-client";
import { updateInById } from "common/ById";
import produce from "immer";
import { InboundReducerFunction } from "./InboundReducerFunction";

export const updateShipmentReducer: InboundReducerFunction = (state, { shipmentId, updatedShipment }) =>
  produce(state, (draft) => {
    draft.shipments = updateInById<InboundShipment>(() => updatedShipment, shipmentId, draft.shipments);
  });
